import { api_configuration } from "../../common";
import api_views = api_configuration.libraries.gui_definition_lib.types.views.alan_api;
import client_state_api = api_configuration.types.client_state.alan_api;
import addQueryIfNotExistsAndGet = require("../state/addQueryIfNotExistsAndGet");
import reQuery = require("../state 2 interface/reQuery");
import getQueryInstanceKey from "../state/getQueryInstanceKey";
import DestructorTree from "../DestructorTree";
import { resetFilters } from "./instructions/queryFilter";
import { subscribeToTranslation } from "../state/phrases";
import { toStream } from "../toStream";

export function initializeQueryWithModelBinding(
	context_node: client_state_api.Cnode,
	node_type: api_views.Cnode__query_context,
	destructor: DestructorTree
): client_state_api.Cquery__client_state {
	const query_definition = node_type.parent.properties.query_context.state.node.output.query();
	const query_context = addQueryIfNotExistsAndGet.forQuery(context_node, query_definition, (query_context) => {
		const query_expression = toStream(query_context.properties.delay_query).stateSwitch({
			no: () =>
				toStream(context_node.properties.location).pipe((location) => {
					query_expression.unsubscribe(subscription);
					destruction_subscription.unsubscribe();
					switch (location.tag) {
						case "local":
							break;
						case "remote":
							query_context.properties.has_result.set("no", {});
							resetFilters(query_context);
							break;
					}
					return undefined;
				})(),
			yes: () => undefined,
		})();
		const subscription = query_expression.subscribe({ update: () => undefined });
		const destruction_subscription = destructor.onDestroy(() => query_expression.unsubscribe(subscription));
		for (const [, column] of query_context.properties.columns) {
			subscribeToTranslation(column.key.ref.properties.name.entry, destructor, (translation) => {
				column.set_name(translation);
			});
			switch (column.properties.type.state.name) {
				case "file":
					break;
				case "number":
					break;
				case "state group": {
					const state_group = column.properties.type.state.node;
					switch (state_group.properties.has_filter.state.name) {
						case "no":
							break;
						case "yes": {
							const $ = state_group.properties.has_filter.state.node;
							for (const [name, state] of $.properties.states) {
								subscribeToTranslation(name, destructor, (translation) => {
									state.set_name(translation);
								});
							}
							break;
						}
						default:
							unexpectedState(state_group.properties.has_filter.state);
					}
					break;
				}
				case "text":
					break;
				case "widget":
					break;
				default:
					unexpectedState(column.properties.type.state);
			}
		}

		(query_context as any).__configuration = node_type.parent.properties.configuration;
	});

	type QueryDependencyCounter = { dependency_count: number };
	const query_patch = query_context as any as QueryDependencyCounter;
	if (query_patch.dependency_count === undefined) {
		query_patch.dependency_count = 1;
	} else {
		query_patch.dependency_count += 1;
	}
	destructor.onDestroy(() => {
		if (query_context.destroyed) {
			return;
		}
		query_patch.dependency_count = query_patch.dependency_count - 1;
		if (query_patch.dependency_count <= 0) {
			const query_instance_name = getQueryInstanceKey(query_definition);
			context_node.properties.queries.delete(query_instance_name);
		}
	});

	type RefreshingQuery = { _refresh_interval?: boolean };
	const query_as_refresh = query_context as unknown as RefreshingQuery;
	if (query_as_refresh._refresh_interval !== true) {
		switch (node_type.parent.properties.has_refresh_interval.state.name) {
			case "yes": {
				query_as_refresh._refresh_interval = true;
				const yes_has_refresh_interval = node_type.parent.properties.has_refresh_interval.state.node;
				const execute_query = () => {
					switch (query_context.properties.delay_query.state.name) {
						case "no": {
							reQuery.execute(query_context);
							break;
						}
						case "yes": {
							break;
						}
						default:
							unexpectedState(query_context.properties.delay_query.state);
					}
				};
				execute_query();
				const timer = setInterval(() => {
					execute_query();
				}, yes_has_refresh_interval.properties.interval.value * 1000);
				destructor.onDestroy(() => clearInterval(timer));
				break;
			}
			case "no":
				break;
			default:
				unexpectedState(node_type.parent.properties.has_refresh_interval.state);
		}
	}
	return query_context;
}
